export const initiateDownload = (url: string) => {
  // Appending the element to the body is only necessary so it can be found by
  // Cypress. So is waiting before removing it.

  const a = document.createElement('a');

  a.href = url;
  a.setAttribute('data-cy-magic-download-link', 'true');
  a.download = '';

  document.body.appendChild(a);

  a.click();

  setTimeout(() => {
    document.body.removeChild(a);
  }, 1000);
};
